module.exports = __webpack_public_path__ + "static/media/harman_redesign.a17edf11.png";